import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-full-content-layout',
  templateUrl: './full-content-layout.component.html',
  styleUrls: ['./full-content-layout.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterOutlet]
})
export class FullContentLayoutComponent {

  constructor() { }

}
